/**
 * When authenticated: logout after 8 hours with no mouse/keyboard/API activity.
 */

'use client'

import { useEffect } from 'react'
import { useSession } from 'next-auth/react'
import {
  SESSION_IDLE_CHECK_MS,
  SESSION_IDLE_MS,
  clearSessionActivity,
  getLastSessionActivity,
  performIdleLogout,
  touchSessionActivity,
} from '@/libs/session-idle'

export function useSessionIdleLogout() {
  const { status } = useSession()

  useEffect(() => {
    if (status === 'unauthenticated') {
      clearSessionActivity()
      return
    }

    if (status !== 'authenticated') return

    if (!getLastSessionActivity()) {
      touchSessionActivity()
    }

    const onActivity = () => touchSessionActivity()
    const events: (keyof WindowEventMap)[] = ['mousemove', 'mousedown', 'keydown', 'scroll', 'touchstart', 'click']
    for (const ev of events) {
      globalThis.addEventListener(ev, onActivity, { passive: true })
    }

    const check = () => {
      const last = getLastSessionActivity()
      if (!last) return
      if (Date.now() - last >= SESSION_IDLE_MS) {
        void performIdleLogout()
      }
    }

    check()
    const id = globalThis.setInterval(check, SESSION_IDLE_CHECK_MS)

    return () => {
      globalThis.clearInterval(id)
      for (const ev of events) {
        globalThis.removeEventListener(ev, onActivity)
      }
    }
  }, [status])
}
